export default __webpack_public_path__ + "static/media/cryptocasinos_approved_logo.ab3835b4.svg";